export const production = 'https://silver-bot-yup3.onrender.com'
export const dev = 'http://localhost:3001'